import { forwardRef, type Ref, type SVGProps } from "react";

function SvgLimitedSubstageBadge(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={87} height={87} fill="none" {...props}>
      <g clipPath="url(#limited-substage-badge_svg__a)">
        <path
          fill="url(#limited-substage-badge_svg__b)"
          stroke="#9ED79D"
          strokeWidth={2}
          d="M34.585 4.692c4.924-4.923 12.906-4.923 17.83 0l1.02 1.02a14.6 14.6 0 0 0 10.33 4.28h.26c6.963 0 12.608 5.645 12.608 12.608v.26c0 3.875 1.54 7.59 4.28 10.33l1.02 1.02c4.923 4.924 4.923 12.906 0 17.83l-1.02 1.02a14.6 14.6 0 0 0-4.28 10.33v.26c0 6.963-5.645 12.608-12.608 12.608h-.26a14.6 14.6 0 0 0-10.33 4.28l-1.02 1.02c-4.924 4.923-12.906 4.923-17.83 0l-1.02-1.02a14.6 14.6 0 0 0-10.33-4.28h-.26c-6.963 0-12.608-5.645-12.608-12.608v-.26c0-3.874-1.54-7.59-4.28-10.33l-1.02-1.02c-4.923-4.924-4.923-12.906 0-17.83l1.02-1.02a14.6 14.6 0 0 0 4.28-10.33v-.26c0-6.963 5.645-12.608 12.608-12.608h.26c3.875 0 7.59-1.54 10.33-4.28z"
        />
        <path
          fill="url(#limited-substage-badge_svg__c)"
          d="m23.746 33.99 18.7-10.286a2.19 2.19 0 0 1 2.108 0l18.7 10.286A2.187 2.187 0 0 1 64 37.15L45.3 64.263a2.187 2.187 0 0 1-3.6 0L22.997 37.15a2.187 2.187 0 0 1 .747-3.159"
        />
      </g>
      <defs>
        <linearGradient
          id="limited-substage-badge_svg__b"
          x1={24.094}
          x2={43.5}
          y1={0}
          y2={86.25}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset={1} stopColor="#B9EBBA" />
        </linearGradient>
        <linearGradient
          id="limited-substage-badge_svg__c"
          x1={29.575}
          x2={43.499}
          y1={28.655}
          y2={65.208}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#094534" />
          <stop offset={1} stopColor="#4D9863" />
        </linearGradient>
        <clipPath id="limited-substage-badge_svg__a">
          <path fill="#fff" d="M.375 0h86.25v86.25H.375z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLimitedSubstageBadge);
export default ForwardRef;
